export const archivedFilterOptions = [
  { label: 'Active', value: false },
  { label: 'Archived', value: true },
];
